import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Title, Text, Container, Button, Overlay, createStyles,
} from '@mantine/core';
import { Link } from 'react-router-dom';
import Constants from '../config/constants';

const useStyles = createStyles((theme) => ({
  wrapper: {
    position: 'relative',
    padding: 30,
    backgroundImage: 'url(/images/foto-mirando-a-pantalla.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    '@media (max-width: 520px)': {
      padding: 20,
    },
  },

  inner: {
    position: 'relative',
    zIndex: 1,
  },

  title: {
    fontWeight: 800,
    fontSize: 40,
    letterSpacing: -1,
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    color: theme.white,
    marginBottom: theme.spacing.xs,
    textAlign: 'center',
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    '@media (max-width: 520px)': {
      fontSize: 28,
    },
  },

  highlight: {
    color: theme.colors[theme.primaryColor][4],
  },

  subtitle: {
    color: theme.colors.gray[0],
    paddingBlock: '1rem',

    '@media (max-width: 520px)': {
      paddingBlock: '0.5rem',
      fontSize: 20,
    },
  },

  description: {
    color: theme.colors.gray[0],
    textAlign: 'center',
    lineHeight: '2rem',
    textShadow: '-20px 0 20px #000, 0 -20px 20px #000, 0 20px 20px #000, 20px 0 20px #000',

    '@media (max-width: 520px)': {
      '> p': {
        fontSize: theme.fontSizes.md,
        lineHeight: '1.3rem',
        marginBlock: '0.7rem',
      },
    },
  },

  controls: {
    marginTop: theme.spacing.xl * 1.5,
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing.md,
    alignItems: 'center',
    width: '100% !important',
  },

  control: {
    height: 42,
    width: '100%',
    maxWidth: '20ch',
    borderRadius: '0.3rem',
    fontSize: theme.fontSizes.md,
  },

  secondaryControl: {
    backgroundColor: 'rgba(255, 255, 255, .4)',

    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, .45) !important',
    },
  },
}));

export default function ProfileBanner() {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const descriptionItems = t('description', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  return (
    <div className={classes.wrapper}>
      <Overlay color="#000" opacity={0.40} zIndex={1} />

      <div className={classes.inner}>
        <Title className={classes.title}>
          Jorge
          {' '}
          <Text component="span" inherit className={classes.highlight}>
            Tobarra del Buey
          </Text>
        </Title>
        <Title align="center" order={2} className={classes.subtitle}>{t('subtitle')}</Title>

        <Container size={740}>
          <Text size="lg" className={classes.description}>
            {descriptionItems.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Text>
        </Container>

        <div className={classes.controls}>
          <Button className={classes.control} variant="white" size="lg" component={Link} to="/portfolio">
            {t('portfolio.title')}
          </Button>
          <Button className={cx(classes.control, classes.secondaryControl)} size="lg" component="a" href={Constants.GITHUB_LINK} target="_blank" rel="noreferrer">
            Github
          </Button>
        </div>
      </div>
    </div>
  );
}
